import { lazy } from 'react';

// Patrols
export const LazyPatrols = lazy(
  () =>
    import(
      /* webpackChunkName: "patrols" */
      /* webpackMode: "lazy" */
      /* webpackPrefetch: true */
      '~/pages/Patrols/Patrols'
    ),
);

export const LazyPatrolsActive = lazy(
  () =>
    import(
      /* webpackChunkName: "patrols" */
      '~/pages/Patrols/PageActive/PatrolActive'
    ),
);

export const LazyPatrolsList = lazy(
  () =>
    import(
      /* webpackChunkName: "patrols" */
      '~/pages/Patrols/PageList/PatrolsList'
    ),
);

export const LazyPatrolsRules = lazy(
  () =>
    import(
      /* webpackChunkName: "patrols" */
      '~/pages/Patrols/PageRules/PatrolsRules'
    ),
);
